export default __webpack_public_path__ + "static/media/zanahoria.cc8d04e8.jpeg";